// 签约状态查询
import axiosRequest from '@/utils/request'

export const query = (params) => {
  return axiosRequest({
    url: '/sign/query',
    method: 'get',
    params
  })
}
